import { GetterTree } from 'vuex'
import { TPlussvrInfo } from './types'

const getters: GetterTree<any, any> = {
  isJoinEnterprisePlus (state: TPlussvrInfo) {
    return state.isJoinEnterprisePlus
  },
  enterpriseList (state: TPlussvrInfo) {
    return state.enterpriseList
  }
}

export default getters
